import gql from 'graphql-tag';

export default gql`
  mutation InviteUser($email: String!, $role: UserRole!, $firstName: String, $lastName: String) {
    inviteUser(data: { email: $email, role: $role, firstName: $firstName, lastName: $lastName }) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/InviteUser.ts